import React, { useContext, useState } from "react";
import {
  GridContainer,
  AcquirerListRootArea,
  GridItem,
} from "./IsoEnrollment.styles";
import { Button, Typography, Tabs, Tab, Box } from "@mui/material";
import DataTable from "../../dataTable/DataTable";
import ListSearchField from "../../listSearchField/ListSearchField";
import { useEffectOnce } from "../../../utils/effects";
import AuthContext from "../../../context/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import LoadISOEnrollment from "../LoadISOEnrollment/LoadISOEnrollment";
import { getIsoEnrollmentList } from "./IsoEnrollment.thunk";
import IsoEnrollmentShow from "./IsoEnrollmentShow";
import {
  setIsoEnrollmentSelected,
  setIsoEnrollmentDataById,
} from "./IsoEnrollment.slice";

const IsoEnrollmentList = (props) => {
  const {
    setSubmenuAdministrativeOpen,
    setSubmenuAdministrativeOption,
    setSelectedOption,
    setNameSection,
  } = props;
  const dispatch = useDispatch();
  const {
    isoEnrollmentData, // Usar los datos paginados en lugar de isoEnrollmentData
    status,
    page,
    pageSize,
    totalRecords,
  } = useSelector((state) => state.isoEnrollment);
  const { token, acquirerData } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(0);
  const [isoEnrollmentId, setIsoEnrollmentId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");

  const buildListPayload = (overrides = {}) => {
    const search = "search" in overrides ? overrides.search : appliedSearch;
    return {
      token,
      acquirerData,
      page: overrides.page ?? page,
      page_size: overrides.page_size ?? pageSize,
      ...(search && { search }),
    };
  };

  const loadList = (overrides = {}) => {
    dispatch(getIsoEnrollmentList(buildListPayload(overrides)));
  };

  const handleSearch = () => {
    const nextSearch = searchValue.trim();
    setAppliedSearch(nextSearch);
    loadList({ page: 1, search: nextSearch });
  };

  const handleClearSearch = () => {
    setSearchValue("");
    setAppliedSearch("");
    loadList({ page: 1, search: "" });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffectOnce(() => {
    loadList();
  });

  const handleEdit = async (row) => {
    // Establecer los datos completos del ISO para edición
    dispatch(setIsoEnrollmentDataById(row));
    dispatch(setIsoEnrollmentSelected(row.isoID));
    setSubmenuAdministrativeOpen(true);
    setSubmenuAdministrativeOption("iso_enrollment_area");
    setSelectedOption("iso_enrollment");
    setNameSection("Administrative - Edit ISO Enrollment");
  };

  const handleAdd = () => {
    dispatch(setIsoEnrollmentDataById(null));
    dispatch(setIsoEnrollmentSelected(null));
    setSubmenuAdministrativeOpen(true);
    setSubmenuAdministrativeOption("iso_enrollment_area");
    setSelectedOption("iso_enrollment");
    setNameSection("Administrative - Create ISO Enrollment");
  };

  const handleShow = async (isoData) => {
    setIsoEnrollmentId(isoData);
  };

  const handlePageChange = (event, newPage) => {
    loadList({ page: newPage + 1 });
  };

  const handleRowsPerPageChange = (event) => {
    const newPageSize = +event.target.value;
    loadList({ page: 1, page_size: newPageSize });
  };

  const columns = [
    { id: "isoID", label: "ISO ID" },
    { id: "isoName", label: "ISO Name" },
    { id: "isoCurrencyCode", label: "Currency" },
    {
      id: "action",
      label: "Actions",
      actions: [
        {
          icon: <VisibilityIcon />,
          label: "Show",
          onClick: (row) => handleShow(row),
        },
        {
          icon: <EditIcon />,
          label: "Set to Complete",
          onClick: (row) => handleEdit(row),
        },
      ],
    },
  ];

  return (
    <AcquirerListRootArea>
      <GridContainer>
        <GridContainer justifyContent="space-between" alignItems="center">
          <GridItem xs={10}>
            <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>
              ISO Enrollment
            </Typography>
          </GridItem>
          <GridItem xs={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAdd}
              size="small"
            >
              Add
            </Button>
          </GridItem>
        </GridContainer>

        {/* Tabs */}
        <GridItem xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="iso enrollment tabs"
            >
              <Tab label="Active" />
              <Tab label="In Progress" />
            </Tabs>
          </Box>
        </GridItem>

        {/* Tab Content */}
        <GridItem xs={12}>
          {activeTab === 0 && (
            <Box sx={{ mt: 2 }}>
              <Box sx={{ mb: 2, maxWidth: { xs: "100%", sm: 360 } }}>
                <ListSearchField
                  fullWidth
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onSearch={handleSearch}
                  placeholder="ISO ID or name"
                />
              </Box>
              <DataTable
                loading={status === "loading"}
                columns={columns}
                rows={isoEnrollmentData}
                page={page - 1}
                rowsPerPage={pageSize}
                count={totalRecords}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ mt: 2 }}>
              <LoadISOEnrollment
                setSubmenuMerchantTerminal={setSubmenuAdministrativeOption}
                setSelectedOption={setSelectedOption}
                setNameSection={setNameSection}
              />
            </Box>
          )}
        </GridItem>
      </GridContainer>

      {/* Modal de visualización */}
      <IsoEnrollmentShow
        isoData={isoEnrollmentId}
        setIsoData={setIsoEnrollmentId}
      />
    </AcquirerListRootArea>
  );
};

export default IsoEnrollmentList;
